
const PRODCT_LIST_UPDATE_LIST= 'PRODCT_LIST_UPDATE_LIST';
const PRODCT_LIST_UPDATE_CONDIION = 'PRODCT_LIST_UPDATE_CONDIION';
const PRODCT_LIST_UPDATE_PAGE = 'PRODCT_LIST_UPDATE_PAGE';
const PRODCT_LIST_UPDATE_MODALVALUE = 'PRODCT_LIST_UPDATE_MODALVALUE';


const ProductClassModel = function() {
    const name = 'productClass_list';
    return {
        name,
        state: {
          list: [],
          condition: {
            productName:'',
            categoryId:'',
            status:'',
            brandId:'',
          },
          modalValue:{
            categoryName:'', 
          },
          page: {
              current: 1,
              total: 0,
              pageSize:30,
          },
        },
        selectors: (state) => {
            const currentState = state[name];
            const selectors = {
              getList: () => currentState.list,
              getCondition: () => currentState.condition,
              getPage: () => currentState.page,
              getModalValue: () => currentState.modalValue,
            };
            return selectors;
        },
        actions: {
          changeList: (list) => (dispatch, getState) => {
            dispatch({
                type: PRODCT_LIST_UPDATE_LIST,
                list
            });
          },
          changeCondition: (key, value) => (dispatch, getState) => {
              dispatch({
                  type: PRODCT_LIST_UPDATE_CONDIION,
                  key,
                  value
              });
          },
          changePage: (page) => (dispatch, getState) => {
                dispatch({
                    type: PRODCT_LIST_UPDATE_PAGE,
                    page
                });
            },
          changeModalValue: (key, value) => (dispatch, getState) => {
            dispatch({
                type: PRODCT_LIST_UPDATE_MODALVALUE,
                key, value
            });
          },
        },
        reducers: {
          list: (state=ProductClassModel.state.list, action) => {
            if (action.type === PRODCT_LIST_UPDATE_LIST) {
              return [...action.list];
            }
            return state;
          },
          condition: (state=ProductClassModel.state.condition, action) => {
                if (action.type === PRODCT_LIST_UPDATE_CONDIION) {
                  const { key, value } = action;
                  let obj = {};
                  obj[key] = value;
                  return Object.assign({}, state, obj);
                }
                return state;
          },
          page: (state=ProductClassModel.state.page, action) => {
            if (action.type === PRODCT_LIST_UPDATE_PAGE) {
              return Object.assign({}, state, action.page);
            }
            return state;
          },
          modalValue: (state=ProductClassModel.state.modalValue, action) => {
            if (action.type === PRODCT_LIST_UPDATE_MODALVALUE) {
              const { key, value } = action;
              let obj = {};
              obj[key] = value;
              return Object.assign({}, state, obj);
            }
            return state;
          },
        }
    };
}();

export default ProductClassModel;


// WEBPACK FOOTER //
// ./src/models/ProductClassModel.js